import { CrmStrategyBaseClass } from '../crm-strategy-base-class';

export class SalesforceService extends CrmStrategyBaseClass {
  constructor() {
    super();
  }

  getTypeString() {
    return 'salesforce';
  }

  getDefaultLoginUrl() {
    return 'https://login.salesforce.com/';
  }

  isPersonAccountEnabled(organization) {
    return organization.object_description.Account.fields.map(f => f.name).includes('IsPersonAccount')
  }

  getNewContactCreationMode(organization, companyId) {
    let formUrl;
    if (companyId === 102) {
      formUrl = 'https://christiandior--uat.lightning.force.com/lightning/o/Account/new?count=2&nooverride=1&useRecordTypeCheck=1&navigationLocation=MRU_LIST&recordTypeId=0121t0000001oxPAAQ'
    } else if (this.isPersonAccountEnabled(organization)) {
      formUrl = `${organization.instance_url}/lightning/o/Account/new`;
    } else {
      formUrl = `${organization.instance_url}/lightning/o/Contact/new`;
    }
    return {
      mode: 'external-form',
      formUrl: formUrl,
    };
  }

  canMakeIndirectSearch(){
    return true;
  }

  canChooseSearchType(){
    return true;
  }

  defaultSearchType(){
    return 'smart'
  }

  static SalesforceFactory() {
    return new SalesforceService();
  }
}
SalesforceService.SalesforceFactory.$inject = [];
